import type * as api from '@gitbook/api-client';
import { BreadcrumbItem } from '@gitbook/spine-react';
import { getChangeRequestSubject } from '@gitbook/util-format';

import {
    ChangeRequestStatusBadge,
    ChangeRequestSubject,
    getChangeRequestIconBadge,
} from '../../../Components';

/**
 * Breadcrumb item for a change request.
 */
export function SpaceChangeRequestBreadcrumbItem(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
    iconOnly: boolean;
    editable: boolean;
}) {
    const { space, changeRequest, iconOnly } = props;
    const { icon } = getChangeRequestIconBadge(changeRequest.status);
    const editable = props.editable && space.permissions.edit && !iconOnly;
    // on predictable UI, we don't show the change request number. This allows us to run any tests that create CRs in parallel
    const changeRequestNumber = process.env.GITBOOK_PREDICTABLE_UI ? '#' : changeRequest.number;

    return (
        <BreadcrumbItem
            icon={icon}
            iconOnly={iconOnly}
            label={`${getChangeRequestSubject(changeRequest)} - #${changeRequestNumber}`}
            href={{
                screen: {
                    type: 'space',
                    space: space.id,
                    organization: space.organization,
                    changeRequest: changeRequest.number,
                    revision: undefined,
                    mode: undefined,
                },
            }}
        >
            <div className="-ml-1 flex items-center gap-2">
                <div className="flex items-center gap-1">
                    <ChangeRequestSubject
                        space={space}
                        changeRequest={changeRequest}
                        size="small"
                        editable={editable}
                    />
                    <span className="font-normal text-muted">#{changeRequestNumber}</span>
                </div>
                <ChangeRequestStatusBadge changeRequest={changeRequest} withIcon={false} />
            </div>
        </BreadcrumbItem>
    );
}
